import http from '@/services/api/http';

export default {
  getMarkets(limit = 20, page = 1) {
    return http.get(`api/Browse/FilteredMarkets/0?itemsPerPage=${limit}&page=${page}&filterIds=&sort=newest`);
  },
};



// WEBPACK FOOTER //
// ./src/services/api/dashboard.js